module.exports = __webpack_public_path__ + "static/cad-designs18-5b51a47755490325d4b3b49510123c08.png";